const LEGACY_MULTI_ORGANIZATION_ROLES = [19, 12, 3, 4, 5, 6, 18, 32]

export const canAccessMultipleOrganizations = (sessionData: any, permission: string): boolean => {
  const scope = sessionData?.scopes?.[permission]
  if (scope !== undefined) {
    return scope === true || scope === 'all' || scope === 'brand'
  }

  const roles = Array.isArray(sessionData?.roles) ? sessionData.roles : []
  return roles.some(role => LEGACY_MULTI_ORGANIZATION_ROLES.includes(role))
}
